module.exports = __webpack_public_path__ + "static/img/wxgzh_head.98f3b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/wxgzh_head.jpg
// module id = eWQk
// module chunks = 1